export default {
  state: {
    loading: {
      visible: false,
      loadingTxt: ''
    }
  },
  mutations: {
    updateLoadingStatus (state, payload) {
      state.loading = {
        visible: payload.isLoading,
        loadingTxt: payload.loadingTxt || ''
      }
    }
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/vux.js